import React, { useState } from 'react';
import { authService } from '../services/auth.service';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');
    
    try {
      const res = await authService.forgotPassword(email);
      setStatus('success');
      setMessage(res.message);
    } catch (err: any) {
      setStatus('error');
      setMessage(err.message || 'An error occurred. Please try again later.');
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100 p-4">
      <div className="w-full max-w-md bg-white p-8 rounded-xl shadow-lg border border-gray-100 text-center">
        <h2 className="text-2xl font-black text-gray-900 mb-2 tracking-tight">Reset Password</h2>
        <p className="text-sm text-gray-500 mb-6">Enter your email address and we'll send you a link to reset your password.</p>

        {status === 'success' ? (
            <div className="py-4">
                <div className="p-4 bg-green-50 text-green-800 border border-green-200 rounded-lg mb-6 text-sm text-left">
                    {message}
                </div>
                <Link to="/login" className="inline-block w-full py-2.5 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-all">
                    Return to Login
                </Link>
            </div>
        ) : (
            <form onSubmit={handleSubmit} className="space-y-4 text-left">
                {status === 'error' && (
                    <div className="p-3 bg-red-50 text-red-600 text-sm rounded border border-red-100">
                        {message}
                    </div>
                )}
                <div>
                    <label className="block text-sm font-bold text-gray-700 mb-1">Email Address</label>
                    <input 
                        type="email" 
                        required
                        className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 outline-none transition"
                        value={email} 
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                    />
                </div>
                <button 
                    type="submit" 
                    disabled={status === 'loading'}
                    className={`w-full py-2.5 rounded-lg text-white font-bold transition ${status === 'loading' ? 'bg-red-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700 shadow-md'}`}
                >
                    {status === 'loading' ? 'Sending Link...' : 'Send Reset Link'}
                </button>
                <div className="text-center mt-4">
                    <Link to="/login" className="text-sm text-gray-500 hover:text-gray-800 font-medium transition-colors">
                        Cancel and return to login
                    </Link>
                </div>
            </form>
        )}
      </div>
    </div>
  );
}